// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3LbE7","productName":"Table_productName__qcMXS"};